import {
	Flex,
	FormNote,
} from '@bamboohr/fabric';
import c from 'classnames';
import {
	useLayoutEffect,
	useRef,
	useState,
} from 'react';

import {
	formatAmountType,
} from './additional-withholding.domain';

export function AdditionalWithholding(props) {
	const {
		type,
		data,
		viewOnly,
		is2020,
		setAdditionalWithholding = () => {},
		setCurrencyType
	} = props;

	const refInputElement = useRef();
	const refCurrencyToggleElement = useRef();
	const refPercentToggleElement = useRef();

	const [initialDataType, setInitialDataType] = useState(data.type);
	useLayoutEffect(() => {
		if (data.type && !initialDataType) {
			setInitialDataType(data.type);
		}
	}, [data.type, initialDataType]);

	useLayoutEffect(() => {
		if (refCurrencyToggleElement.current.checked) {
			refInputElement.current.classList.add('currency-field');
		} else if (refPercentToggleElement.current.checked) {
			refInputElement.current.classList.add('percent-field');
		}
	}, []);


	const toggleBtnClasses = c(
		'fab-TextToggle',
		{ 'fab-TextToggle--disabled': viewOnly }
	);
	const labelClasses = c(
		'fab-Label',
		{ 'fab-Label--disabled': viewOnly }
	);

	const toggleInputCurrencyClasses = 'fab-TextToggle__input';
	const toggleInputPercentClasses = 'fab-TextToggle__input';
	const toggleLabelClasses = 'fab-TextToggle__label bhrToggle__label bhrToggle--btn__label';
	const toggleHandleClasses = 'fab-TextToggle__handle bhrToggle__handle bhrToggle--btn__handle';

	const inputClass = `.js-${ type }AdditionalWithholding`;

	const maxWithholdingAmount = data?.range?.max || 999999999.99;

	const handleWithholdingChange = (event) => {
		setAdditionalWithholding(formatAmountType(event.target.value, data.type))
	}

	return (
        (<div className="AdditionalWithholding fab-FormColumn">
            {/* toggle button */}
            <label className={ labelClasses } htmlFor={ `${ type }Additional` }>
				{ is2020 ? $.__('Extra Withholding') : $.__('Additional Withholding') }
			</label>
            <Flex alignItems="center" gap={1}>
				<div className={ toggleBtnClasses }>
					<input
						className={ toggleInputCurrencyClasses }
						data-currency-toggle="$"
						data-field-class={ `js-${ type }AdditionalWithholding` }
						data-flag="currency"
						defaultChecked={ initialDataType === 'currency' ? 'checked' : null }
						disabled={ viewOnly }
						id={ `${ type }Currency` }
						name={ `${ type }[withholdExtraType]` }
						onBlur={ handleAdditionalWithholdingBlur }
						onChange={ event => {
							window.BambooHR.Utils.formatCurrencyPercentToggle(event.target, inputClass, 2, false, ',', '.');
							setCurrencyType(event.target.value === '%' ? 'percent' : 'currency');
							setAdditionalWithholding(formatAmountType(data.amount, event.target.value === '%' ? 'percent' : 'currency'));
						}}
						ref={ refCurrencyToggleElement }
						type="radio"
						value="$"
					/>
					<label className={ toggleLabelClasses } htmlFor={ `${ type }Currency` }>$</label>
					<input
						className={ toggleInputPercentClasses }
						data-currency-toggle="%"
						data-field-class={ `js-${ type }AdditionalWithholding` }
						data-flag="percent"
						defaultChecked={ initialDataType === 'percent' ? 'checked' : null }
						disabled={ viewOnly }
						id={ `${ type }Percentage` }
						name={ `${ type }[withholdExtraType]` }
						onBlur={ handleAdditionalWithholdingBlur }
						onChange={ event => {
							window.BambooHR.Utils.formatCurrencyPercentToggle(event.target, inputClass, 2, false, ',', '.');
							setCurrencyType(event.target.value === '%' ? 'percent' : 'currency');
							setAdditionalWithholding(formatAmountType(data.amount, event.target.value === '%' ? 'percent' : 'currency'));
						}}
						ref={ refPercentToggleElement }
						type="radio"
						value="%"
					/>
					<label className={ toggleLabelClasses } htmlFor={ `${ type }Percentage` }>%</label>
					<span className={ toggleHandleClasses }></span>
				</div>

				{/* input field */}
				<Flex alignItems="center" gap={1}>
                    <input
                        className={ `AdditionalWithholding__amount fab-TextInput fab-TextInput--width5 js-${ type }AdditionalWithholding` }
                        data-allow-negative-amount={data.allowNegativeAmount}
                        data-cursymbol="$"
                        data-decimal-char="."
                        data-range-max={maxWithholdingAmount}
                        data-range-min={data?.range?.min || 0}
                        data-thousands-separator=","
                        defaultValue={ data.amount }
                        disabled={ viewOnly }
                        id={ `${ type }Additional` }
                        name={ `${ type }[withholdExtraValue]` }
                        onBlur={ handleAdditionalWithholdingBlur }
                        onChange={ handleWithholdingChange }
                        ref={ refInputElement }
                        type="text"
                    />
                    <FormNote>{ $.__('Per Pay Period') }</FormNote>
                </Flex>
				
			</Flex>
        </div>)
    );

	function handleAdditionalWithholdingBlur() {
		if (!refCurrencyToggleElement.current || !refPercentToggleElement.current) {
			return;
		}

		// default to true
		const fixNegativeAmount = data ? !data.allowNegativeAmount : true;

		if (refCurrencyToggleElement.current.checked) {
			window.BambooHR.Utils.formatCurrencyPercentToggle(refCurrencyToggleElement.current, inputClass, 2, fixNegativeAmount, ',', '.');
		} else if (refPercentToggleElement.current.checked) {
			window.BambooHR.Utils.formatCurrencyPercentToggle(refPercentToggleElement.current, inputClass, 2, true);
		}

		const stateInputClass = '.js-stateAdditionalWithholding';
		const fedInputClass = '.js-fedAdditionalWithholding';

		// Check for errors on both inputs
		const $stateInput = $(stateInputClass);
		const $fedInput = $(fedInputClass);

		const stateValue = $stateInput.length > 0 ? parseFloat($stateInput.val().replace('$', '').replaceAll(',', '')) || 0 : 0;
		const fedValue = $fedInput.length > 0 ? parseFloat($fedInput.val().replace('$', '').replaceAll(',', '')) || 0 : 0;

		const stateHasError = stateValue > maxWithholdingAmount;
		const fedHasError = fedValue > maxWithholdingAmount;

		if (stateHasError) {
			$stateInput.val(maxWithholdingAmount);
			$stateInput.blur();
		}
		if (fedHasError) {
			$fedInput.val(maxWithholdingAmount);
			$fedInput.blur();
		}

		if (stateHasError && fedHasError) {
			setMessage($.__('Additional State and Federal Withholding amounts must be less than $1,000,000,000.00'), 'error');
		}
		else if (stateHasError) {
			setMessage($.__('Additional State Withholding amount must be less than $1,000,000,000.00'), 'error');
		}
		else if (fedHasError) {
			setMessage($.__('Extra Federal Withholding amount must be less than $1,000,000,000.00'), 'error');
		}
	}
}
